import { httpClientUser } from 'Api/microservice-http-clients';
import CONFIG from 'Config/index';
import BaseWSClient from 'WSClient/BaseWSClient';

export default class AuthWSClient extends BaseWSClient {
  static async getTemporaryToken() {
    const { data } = await httpClientUser.get('/temporary_token');
    return data.token;
  }

  static async getTemporaryTokenRetry(n) {
    // if we don't get a token then we retry n times
    for (let i = 0; i < n; i++) {
      try {
        // eslint-disable-next-line no-await-in-loop
        return await AuthWSClient.getTemporaryToken();
      } catch (e) {
        // ingnore
      }
      // add some timeout between tries
      // eslint-disable-next-line no-await-in-loop
      await new Promise(resolve => setTimeout(resolve, 3000));
    }

    throw new Error(`Failed retrying get /temporary_token ${n} times`);
  }

  async _connect() {
    const token = await AuthWSClient.getTemporaryTokenRetry(3);
    if (!token) return Promise.reject(new Error('Could not get /temporary_token; Websocket AuthWSClient will not open'));
    this.client = new WebSocket(`${CONFIG.urls.notificationWS}?token=${token}`);
    return Promise.resolve(this.client);
  }
}
